import gql from 'graphql-tag';

export default gql`
  fragment TimestampFields on Timestamp {
    date
    firstName
    lastName
  }
`;
